import { AsyncThunkAction } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from 'app/store/configureStore';
import { useCallback, useEffect, useState } from 'react';
import { useIsMounted } from 'app/utils/hooks';
import { getAuthenticatedSelector } from 'app/store/Auth/selectors';
import useInterval from 'use-interval';
import { GenericObject } from 'types/generic.types';

export const useNotificationCountPoll = (
  effect: AsyncThunkAction<GenericObject<number>, void, any>,
  interval: number
) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const isMounted = useIsMounted();
  const isAuthenticated = useAppSelector(getAuthenticatedSelector);

  const stopPolling = !isAuthenticated || loading || !interval;

  const fetchCount = useCallback(async () => {
    setLoading(true);
    await dispatch(effect);
    if (!isMounted()) {
      return;
    }
    setLoading(false);
  }, [dispatch, effect, isMounted]);

  useInterval(fetchCount, stopPolling ? null : interval * 1000, false);

  useEffect(() => {
    if (isAuthenticated) {
      fetchCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isAuthenticated]);

  return null;
};
